import { Link } from 'react-router-dom';

interface ProductCard {
  title: string;
  href: string;
  imageUrl: string;
  imageClass?: string;
}

const PRODUCTS: ProductCard[] = [
  {
    title: 'Навесы для автомобилей (машин)',
    href: '/products/carports',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/beea050e-23fc-4d87-803b-e0dd28d0d50e_compressed_photo_2026-07-27-18.06.39.webp',
  },
  {
    title: 'Козырьки',
    href: '/products/canopies',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/6d003a34-d8ea-4b86-9c00-84829ed07f95_compressed_photo_2026-07-27-18.06.43.webp',
  },
  {
    title: 'Беседки',
    href: '/products/gazebos',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/eecc46ce-0897-4f51-aadd-ca278d0e4b23_compressed_IMG_2545.webp',
  },
  {
    title: 'Ворота и калитки',
    href: '/products/gates',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/9cfe3f66-baa4-4ee6-825b-cb23f51b99ba_compressed_IMG_0825.webp',
  },
  {
    title: 'Мангальные зоны',
    href: '/products/bbq',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20barbecue%20area%20with%20metal%20roof%20canopy%20brick%20grill%20simple%20practical%20design%20garden%20setting%20daytime%20natural%20lighting%20casual%20realistic%20photography%20ordinary%20backyard&width=800&height=600&seq=prod-bbq&orientation=landscape&nocache=true',
  },
  {
    title: 'Кованые оградки для могил',
    href: '/products/grave-fences',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/cc9320d2-107b-4b84-8123-4f291fb5abb0_compressed_DSC01194.webp',
  },
  {
    title: 'Перила',
    href: '/products/railings',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/411cb964-6df6-4532-ad9e-58e573066d9b_compressed_SSA57590.webp',
  },
  {
    title: 'Каминные наборы',
    href: '/products/fireplace-sets',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/861113ac-a618-44f3-972b-e5806b569b22_compressed_DSC09273.webp',
  },
  {
    title: 'Кованная мебель',
    href: '/products/wrought-furniture',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/8db1a512-0dd6-4b23-9fda-3dd8a98941a4_compressed_IMG_0131.webp',
  },
  {
    title: 'Решётки для окон',
    href: '/products/window-grilles',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/f2fc6511-aea8-4de6-ab97-4501581c7feb_compressed_DSC01345.webp',
    imageClass: 'rotate-90',
  },
  {
    title: 'Качели',
    href: '/products/swings',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/5a72c1d8-20bd-41f0-9c28-c02e21b58c0a_compressed_IMG_0425.webp',
  },
  {
    title: 'Скамейки',
    href: '/products/benches',
    imageUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/9620df55-5e60-46ce-aa1e-6745ba0eddaa_compressed_SSA57690.webp',
  },
];

export default function ProductsPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50" id="products">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Что мы изготавливаем
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Создаём надёжные металлоконструкции любой сложности по&nbsp;индивидуальным размерам
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-product-shop="">
          {PRODUCTS.map((product) => (
            <div
              key={product.href}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-400 hover:border-primary-200/50"
            >
              <div className="relative w-full h-56 md:h-64 overflow-hidden">
                <img
                  src={product.imageUrl}
                  alt={product.title}
                  className={`w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105 ${product.imageClass || ''}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400"></div>
              </div>

              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-4">
                  {product.title}
                </h3>
                <div className="flex items-center gap-2.5 flex-wrap">
                  <a
                    href="#cta-form"
                    className="whitespace-nowrap bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer"
                  >
                    Заказать
                  </a>
                  <Link
                    to={product.href}
                    className="whitespace-nowrap border border-background-300 hover:border-background-400 text-foreground-700 font-medium text-sm px-5 py-2.5 rounded-md transition-all duration-300 cursor-pointer"
                  >
                    Подробнее
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}